module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/staff-reward-legacy-b9701875803f04224c0d7de9383cbcfc.svg";